// チャットボット用モックデータ

export type ChatMessage = {
  role: "bot" | "user";
  text: string;
  time: string;
};

export const previewMessages: ChatMessage[] = [
  {
    role: "bot",
    text: "こんにちは！株式会社ポータル商事のサポートボットです。どのようなご質問でしょうか？",
    time: "10:32",
  },
  {
    role: "user",
    text: "料金プランについて知りたいです。",
    time: "10:32",
  },
  {
    role: "bot",
    text: "料金プランは3種類ご用意しています。\n・ライト: 月額 9,800円\n・スタンダード: 月額 29,800円\n・エンタープライズ: 個別見積もり\n詳細は料金ページをご覧ください。",
    time: "10:33",
  },
  {
    role: "user",
    text: "スタンダードプランで何ができますか？",
    time: "10:33",
  },
  {
    role: "bot",
    text: "スタンダードプランでは、AIブログ生成・チャットボット・アクセス解析・メール対応など、すべての機能をご利用いただけます。担当者とのご相談も可能です。",
    time: "10:34",
  },
];

export const chatStats = {
  todayInquiries: 142,
  resolutionRate: 87.5,
  avgResponseTime: "1.2 秒",
};

export const colorChoices = ["#2563eb", "#16a34a", "#ec4899", "#f59e0b", "#6366f1", "#0f172a"];

export const learningData = [
  { source: "FAQ", count: 48, status: "学習済" },
  { source: "ブログ記事", count: 32, status: "学習済" },
  { source: "サービスページ", count: 14, status: "学習済" },
  { source: "アップロードPDF", count: 6, status: "処理中" },
];
